import DataTableIniter from '../../components/dataTablesIniter';

namespace('IO.Views.UserGroups', function (exports) {
  'use strict';

  var Index = DataTableIniter.extend({
    dom: {
      DATATABLES: '.io-table',
      DELETE_ACTION: '#delete-action',
      CHECKED_POLICY: '.row-checkbox:checked',
    },

    opts: {
      filter: true,
      title: 'Click to edit',
      serverSide: false,
      aoColumnDefs: [
        {
          aTargets: [0],
        },
      ],
    },

    events: function () {
      var events = {};

      return events;
    },

    render: function () {
      var rawTables = this.$el.find(this.dom.DATATABLES),
        i;

      this.dataTables = [];

      for (i = rawTables.length - 1; i >= 0; i--) {
        this._setupDatatable($(rawTables[i]));
      }
    },
  });

  exports.Index = Index;
});
